export default [
  'instructor',
  'location'
];
